export default "__VITE_ASSET__8cebdafe__"